import createSvgIcon from '../Utils/CreateSvgIcon';

export const UploadCloud = createSvgIcon(
  <g transform="translate(-10 -10)">
    <path
      d="M25.3346 24.3333L22.0013 21L18.668 24.3333M22.0013 21V28.5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
    <path
      d="M28.668 24.9524C29.6859 24.1117 30.3346 22.8399 30.3346 21.4167C30.3346 18.8854 28.2826 16.8333 25.7513 16.8333C25.5692 16.8333 25.3989 16.7383 25.3064 16.5814C24.2197 14.7374 22.2133 13.5 19.918 13.5C16.4662 13.5 13.668 16.2982 13.668 19.75C13.668 21.4718 14.3642 23.0309 15.4904 24.1613"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </g>,
  'UploadCloud',
);
